import { render, staticRenderFns } from "./BusinessPlan.vue?vue&type=template&id=ad839d08&scoped=true"
import script from "./BusinessPlan.vue?vue&type=script&lang=js"
export * from "./BusinessPlan.vue?vue&type=script&lang=js"
import style0 from "./BusinessPlan.vue?vue&type=style&index=0&id=ad839d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad839d08",
  null
  
)

export default component.exports